module.exports = __webpack_public_path__ + "static/media/pet0.a99315e7.jpg";